var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.02V.576C0 .257.257 0 .575 0h2.446c.152 0 .299.06.406.168l2.54 2.54c.224.224.224.588 0 .812L3.52 5.966c-.224.225-.588.225-.813 0L.168 3.427C.061 3.32 0 3.173 0 3.021zM1.342.768c-.318 0-.575.257-.575.575 0 .318.257.575.575.575.318 0 .575-.257.575-.575 0-.318-.257-.575-.575-.575z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.b8f3e3f7dbf54bb5d64c75b62eec3fbb.svg";
export { ForwardRef as ReactComponent };